var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2386ca;}.b{fill:#b8e6ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M284.421,153.38h-4.175V141.313h12.078v4.137h36.828V141.3h12.085v12.038h-4.112v36.806h4.122v12.138H329.239v-4.131H292.324V202.3H280.261V190.19h4.16Zm3.708-.015v36.847h4.251v4.173h36.867v-4.226h4.144v-36.8h-4.251v-4.173H292.274v4.18Zm.464-3.708v-4.735h-4.729v4.735Zm44.306-.045h4.812V144.9H332.9Zm-49.041,44.308v4.792h4.732v-4.792Zm53.854,4.822v-4.809h-4.793v4.809Z",
    transform: "translate(-280.246 -141.3)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.136 16.249)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35.353,
    height: 29.1,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2392.5,430.5l8.437-8.433,8.1,8.433,6.615-6.472,6.867,6.864V412.447H2392.5Z",
    transform: "translate(-2389.791 -408.757)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 2.599,
    cy: 2.598,
    rx: 2.599,
    ry: 2.598,
    transform: "translate(17.676 8.314)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageBorder);
export default __webpack_public_path__ + "static/media/image-border.e032a3ee.svg";
export { ForwardRef as ReactComponent };